//#region src/parser.ts
var e = class e extends Error {
	expected;
	actual;
	constructor(t, n) {
		super(`Expected ${t} got ${n}`), Error.captureStackTrace && Error.captureStackTrace(this, e), this.name = "ParserError", this.expected = t, this.actual = n;
	}
};
function t(e) {
	return new o(e).run();
}
function n(e) {
	let t = [];
	for (let n of e) typeof n == "string" && typeof t[t.length - 1] == "string" ? t[t.length - 1] += n : t.push(n);
	return t;
}
var r = new Set([
	"\\",
	"|",
	"@",
	"[",
	"]",
	"(",
	")",
	"."
]);
function i(e) {
	return r.has(e);
}
var a = new Set([
	"bold",
	"italic",
	"underline"
]), o = class {
	tokens;
	index;
	constructor(e) {
		this.tokens = e.split(/(\\|\||@|\[|]|\(|\)|\.)/).filter((e) => e != ""), this.index = 0;
	}
	run() {
		return this.parseFormattedString();
	}
	peek() {
		return this.tokens[this.index];
	}
	consume(t) {
		if (t && t != this.peek()) throw new e(t, this.peek());
		this.index++;
	}
	tryParse(t, n) {
		let r = this.index;
		try {
			return t();
		} catch (t) {
			if (t instanceof e) return this.index = r, n;
			throw t;
		}
	}
	parseFormattedString() {
		let e = [];
		for (; this.peek();) e.push(this.parseTextPart());
		return n(e);
	}
	parseTextPart() {
		let e = this.peek();
		switch (e) {
			case "[": return this.parseRubyOrOpenBracket();
			case "@": return this.parseAtMark();
			case "\\": return this.parseEscape();
			case void 0: throw Error("Unexpected EOF");
			default: return this.consume(), e;
		}
	}
	parseString() {
		let e = "", t;
		for (; t = this.peek();) {
			if (t == "\\" && (e += this.parseEscape()), i(t)) return e;
			this.consume(), e += t;
		}
		return e;
	}
	parseAtMark() {
		return this.consume("@"), this.tryParse(() => {
			if (this.peek() == ".") {
				let e = [this.parseTag()];
				for (; this.peek() == ".";) e.push(this.parseTag());
				this.consume("(");
				let t = n(this.parseBracedContent());
				return this.consume(")"), {
					type: "tagged",
					tags: e,
					content: t
				};
			}
			let e = this.parseFormattingTagName();
			this.consume("(");
			let t = n(this.parseBracedContent());
			return this.consume(")"), {
				type: "formatting",
				style: e,
				content: t
			};
		}, "@");
	}
	parseFormattingTagName() {
		let t = this.parseString();
		if (!a.has(t)) throw new e(`formatting tag (one of: ${Array.from(a).join(", ")})`, t);
		return t;
	}
	parseTag() {
		return this.consume("."), this.parseString();
	}
	parseBracedContent() {
		let e = [], t;
		for (; t = this.peek();) {
			if (t == ")") return e;
			e.push(this.parseTextPart());
		}
		return e;
	}
	parseRubyOrOpenBracket() {
		return this.consume("["), this.tryParse(() => {
			let e = n(this.parseRubyPart());
			this.consume("|");
			let t = n(this.parseRubyPart());
			return this.consume("]"), {
				type: "ruby",
				baseText: e,
				annotation: t
			};
		}, "[");
	}
	parseRubyPart() {
		let e = [], t;
		for (; t = this.peek();) {
			if (t == "]" || t == "|") return e;
			e.push(this.parseTextPart());
		}
		return e;
	}
	parseEscape() {
		this.consume("\\");
		let e = this.peek();
		switch (this.consume(), e) {
			case "[":
			case "]":
			case "\\":
			case "|":
			case "@": return e;
			default: return "\\" + e;
		}
	}
};
//#endregion
export { t as parse };
